export const LEAD_DRAWER_OPTIONS = {
  PROFILE: 'profile',
  FILES: 'files',
  MESSAGES: 'chat',
  NOTES: 'notes',
} as const;

export type LeadDrawerOptions =
  typeof LEAD_DRAWER_OPTIONS[keyof typeof LEAD_DRAWER_OPTIONS];
